/* Creative Crispies collection / search pages: progressive enhancement only (everything works without JS).
   - sort select + filter checkboxes submit the form on change; empty price fields are dropped from the URL
   - "Load more" fetches the next page through section rendering and appends its cards
   - while snippets/cc-hidden.liquid hides products, a view that still spans more than one 250-product page is
     loaded in full on page 1 (pager has data-cc-autoload) and the count is set to the cards actually shown
   - the active category chip is scrolled into view on mobile
   - the filter panel closes on outside click / Escape */
(()=>{
  if(window.__ccCollection)return;window.__ccCollection=true;

  const clean=f=>{f.querySelectorAll('input[type=number],input[type=text]').forEach(i=>{if(i.value.trim()==='')i.disabled=true})};
  window.addEventListener('pageshow',()=>document.querySelectorAll('[data-cc-form] input[disabled]:not([type=checkbox])').forEach(i=>i.disabled=false));
  document.addEventListener('submit',e=>{const f=e.target.closest('[data-cc-form]');if(f)clean(f)},true);
  document.addEventListener('change',e=>{const el=e.target.closest('[data-cc-auto]');if(!el)return;const f=el.closest('[data-cc-form]');
    if(f){clean(f);f.requestSubmit?f.requestSubmit():f.submit()}});

  document.addEventListener('click',e=>{
    document.querySelectorAll('[data-cc-filter][open]').forEach(d=>{if(!d.contains(e.target))d.open=false})});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('[data-cc-filter][open]').forEach(d=>{d.open=false;const s=d.querySelector('summary');if(s)s.focus()})});

  const centerChip=()=>document.querySelectorAll('[data-cc-chips]').forEach(ch=>{const on=ch.querySelector('.on');
    if(on&&ch.scrollWidth>ch.clientWidth)ch.scrollLeft=on.offsetLeft-ch.clientWidth/2+on.offsetWidth/2});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',centerChip);else centerChip();

  // fetch the page behind a "Load more" link and append its cards/rows; resolves to the first new card (or null)
  const more=async(a,shop,grid,pager)=>{
    const url=new URL(a.href,location.href);url.searchParams.set('section_id',shop.dataset.section);
    const res=await fetch(url.toString(),{credentials:'same-origin'});if(!res.ok)throw new Error(res.status);
    const doc=new DOMParser().parseFromString(await res.text(),'text/html');
    if(!doc.querySelector('[data-cc-shop]'))throw new Error('no section');
    // a page whose products are all hidden renders no grid: nothing to append, just move the pager on
    const nextGrid=doc.querySelector('[data-cc-grid]');const nextPager=doc.querySelector('[data-cc-pager]');
    const first=nextGrid?nextGrid.firstElementChild:null;
    if(nextGrid)grid.append(...nextGrid.children);
    const rows=shop.querySelector('[data-cc-rows]'),nextRows=doc.querySelector('[data-cc-rows]');
    if(nextRows){if(rows)rows.append(...nextRows.children);else grid.after(nextRows)}
    pager.innerHTML=nextPager?nextPager.innerHTML:'';
    return first;
  };
  const parts=a=>{const shop=a.closest('[data-cc-shop]');const grid=shop&&shop.querySelector('[data-cc-grid]');const pager=shop&&shop.querySelector('[data-cc-pager]');
    return grid&&pager?[shop,grid,pager]:null};

  document.addEventListener('click',async e=>{
    const a=e.target.closest('[data-cc-more]');if(!a)return;
    const p=parts(a);if(!p)return;
    e.preventDefault();
    if(a.getAttribute('aria-busy')==='true')return;
    a.setAttribute('aria-busy','true');const label=a.textContent;a.textContent='Loading...';
    try{
      const first=await more(a,...p);
      if(first){const l=first.querySelector('a');if(l)l.focus({preventScroll:true})}
    }catch(err){location.href=a.href;return}
    a.removeAttribute('aria-busy');a.textContent=label;
  });

  const autoload=async pager=>{
    const shop=pager.closest('[data-cc-shop]');if(!shop)return;
    for(let i=0;i<20;i++){
      const a=pager.querySelector('[data-cc-more]');if(!a)break;
      const p=parts(a);if(!p)return;
      try{await more(a,...p)}catch(err){return}
    }
    // everything is on the page now: drop the numbered pages (they'd reload a partial page)
    if(!pager.querySelector('[data-cc-more]'))pager.innerHTML='';
    const c=shop.querySelector('[data-cc-count]');if(!c)return;
    const n=shop.querySelectorAll('[data-cc-grid] > *, [data-cc-rows] > *').length;
    c.textContent=n+' '+(n===1?c.dataset.one:c.dataset.many);
  };
  const autoloadAll=()=>document.querySelectorAll('[data-cc-pager][data-cc-autoload]').forEach(autoload);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',autoloadAll);else autoloadAll();
})();
